import React from 'react'; // eslint-disable-next-line import/no-unresolved

import { useLocation } from '@reach/router';
import styled, { th } from '@xstyled/styled-components';
var TOP_OFFSET = 100;

function getHeaderAnchors() {
  return Array.prototype.filter.call(document.getElementsByClassName('anchor'), function (testElement) {
    return testElement.parentNode.nodeName === 'H2' || testElement.parentNode.nodeName === 'H3';
  });
}

function getHeaderDataFromAnchor(el) {
  var _el$parentElement, _el$parentElement2;

  return {
    url: el.getAttribute('href'),
    text: (_el$parentElement = el.parentElement) === null || _el$parentElement === void 0 ? void 0 : _el$parentElement.innerText,
    depth: Number((_el$parentElement2 = el.parentElement) === null || _el$parentElement2 === void 0 ? void 0 : _el$parentElement2.nodeName.replace('H', ''))
  };
}

function getAnchorHeaderIdentifier(el) {
  var _el$parentElement3;

  return el === null || el === void 0 ? void 0 : (_el$parentElement3 = el.parentElement) === null || _el$parentElement3 === void 0 ? void 0 : _el$parentElement3.id;
}

export function useTocHighlight(ref) {
  var _useLocation = useLocation(),
      pathname = _useLocation.pathname;

  var _React$useState = React.useState(undefined),
      lastActiveLink = _React$useState[0],
      setLastActiveLink = _React$useState[1];

  var _React$useState2 = React.useState([]),
      headings = _React$useState2[0],
      setHeadings = _React$useState2[1];

  React.useEffect(function () {
    setHeadings(getHeaderAnchors().map(getHeaderDataFromAnchor));
  }, [pathname]);
  React.useEffect(function () {
    var headersAnchors = [];
    var links = [];

    function setActiveLink() {
      function getActiveHeaderAnchor() {
        var index = 0;
        var activeHeaderAnchor = null;
        headersAnchors = getHeaderAnchors();

        while (index < headersAnchors.length && !activeHeaderAnchor) {
          var headerAnchor = headersAnchors[index];

          var _headerAnchor$getBoun = headerAnchor.getBoundingClientRect(),
              top = _headerAnchor$getBoun.top;

          if (top >= 0 && top <= TOP_OFFSET) {
            activeHeaderAnchor = headerAnchor;
          }

          index += 1;
        }

        return activeHeaderAnchor;
      }

      var activeHeaderAnchor = getActiveHeaderAnchor();

      if (activeHeaderAnchor) {
        var index = 0;
        var itemHighlighted = false;
        links = ref.current ? ref.current.querySelectorAll('a') : [];

        while (index < links.length && !itemHighlighted) {
          var link = links[index];
          var href = link.href;
          var anchorValue = decodeURIComponent(href.substring(href.indexOf('#') + 1));

          if (getAnchorHeaderIdentifier(activeHeaderAnchor) === anchorValue) {
            if (lastActiveLink) {
              lastActiveLink.removeAttribute('aria-current');
            }

            link.setAttribute('aria-current', 'true');
            setLastActiveLink(link);
            itemHighlighted = true;
          }

          index += 1;
        }
      }
    }

    document.addEventListener('scroll', setActiveLink);
    document.addEventListener('resize', setActiveLink);
    setActiveLink();
    return function () {
      document.removeEventListener('scroll', setActiveLink);
      document.removeEventListener('resize', setActiveLink);
    };
  });
  return headings;
}
var TocContainer = styled.div.withConfig({
  displayName: "TableOfContents__TocContainer",
  componentId: "sc-1rdixw-0"
})(["position:sticky;top:", ";padding:5 0 4;overflow-y:auto;height:calc(100vh - 50px);font-size:15;h4{margin:0;font-size:14;font-weight:500;text-transform:uppercase;color:on-background-light;}ul{list-style-type:none;padding:0;li{margin:2 0;&[data-depth='3']{padding-left:2;}}}a{display:inline-block;transition:fast;color:on-background-light;text-decoration:none;opacity:0.85;&[aria-current]{font-weight:500;color:on-background;transform:translateX(2px);opacity:1;}&:hover{color:on-background;transform:translateX(2px);opacity:1;}}"], th.px(50));
export function TableOfContents() {
  var ref = React.useRef();
  var headings = useTocHighlight(ref);
  if (!headings.length) return null;
  return /*#__PURE__*/React.createElement(TocContainer, {
    ref: ref
  }, /*#__PURE__*/React.createElement("h4", null, "On this page"), /*#__PURE__*/React.createElement("ul", null, headings.map(function (heading, i) {
    return heading.url ? /*#__PURE__*/React.createElement("li", {
      key: i,
      "data-depth": heading.depth
    }, /*#__PURE__*/React.createElement("a", {
      href: heading.url
    }, heading.text)) : null;
  })));
}